import { RouterModule } from '@angular/router'
import { PreviewMapComponent } from './preview-map.component'
import { CommonModule } from '@angular/common'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgModule } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { MapCoordinatesFinderModule } from '@components/map-coordinates-finder/map-coordinates-finder.module'
import { RadioModule } from '@components/radio/radio.module'

@NgModule({
  declarations: [PreviewMapComponent],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    RouterModule,
    TranslateModule,
    MapCoordinatesFinderModule,
    RadioModule,
  ],
  exports: [PreviewMapComponent],
})
export class PreviewMapModule {}
